import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["src"];
var _hoisted_2 = ["onClick"];
var _hoisted_3 = ["onUpdate:modelValue", "onConfirm", "onKeyup"];
var _hoisted_4 = ["onUpdate:modelValue"];
var _hoisted_5 = ["onClick"];
var _hoisted_6 = ["onClick"];
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal } from '@tencentcloud/universal-api';
import { ref, computed, onMounted, onUnmounted } from '../../../adapter-vue';
import { isPC } from '../../../utils/env';
import { generateAvatar, generateContactInfoName, generateContactInfoBasic, isFriend, isApplicationType } from '../utils/index';
import { contactMoreInfoConfig, contactButtonConfig } from './contact-info-config';
import Icon from '../../common/Icon.vue';
import editSVG from '../../../assets/icon/edit.svg';
import backSVG from '../../../assets/icon/back.svg';
import SwitchBar from '../../common/SwitchBar/index.vue';
import { CONTACT_INFO_LABEL_POSITION, CONTACT_INFO_MORE_EDIT_TYPE, CONTACT_INFO_BUTTON_TYPE } from '../../../constant';
import { deepCopy } from '../../TUIChat/utils/utils';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['switchConversation'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var contactInfoData = ref({});
    var contactInfoBasicList = ref([]);
    var contactInfoMoreList = ref([]);
    var contactInfoButtonList = ref([]);
    var setEditing = item => {
      item.editing = true;
    };
    var isGroup = computed(() => {
      var _contactInfoData$valu;
      return !!((_contactInfoData$valu = contactInfoData.value) !== null && _contactInfoData$valu !== void 0 && _contactInfoData$valu.groupID);
    });
    var isApplication = computed(() => {
      return isApplicationType(contactInfoData === null || contactInfoData === void 0 ? void 0 : contactInfoData.value);
    });
    // is both friend, if is group type always false
    var isBothFriend = ref(false);
    // is group member, including ordinary member, admin, group owner
    var isGroupMember = computed(() => {
      var _contactInfoData$valu2;
      return !!((_contactInfoData$valu2 = contactInfoData.value) !== null && _contactInfoData$valu2 !== void 0 && (_contactInfoData$valu2 = _contactInfoData$valu2.selfInfo) !== null && _contactInfoData$valu2 !== void 0 && _contactInfoData$valu2.userID);
    });
    // is in black list, if is group type always false
    var isInBlackList = computed(() => {
      var _blackList$value;
      return !isGroup.value && ((_blackList$value = blackList.value) === null || _blackList$value === void 0 ? void 0 : _blackList$value.findIndex(item => {
        var _contactInfoData$valu3;
        return (item === null || item === void 0 ? void 0 : item.userID) === ((_contactInfoData$valu3 = contactInfoData.value) === null || _contactInfoData$valu3 === void 0 ? void 0 : _contactInfoData$valu3.userID);
      })) >= 0;
    });
    var blackList = ref([]);
    onMounted(() => {
      TUIStore.watch(StoreName.CUSTOM, {
        currentContactInfo: onCurrentContactInfoUpdated
      });
      TUIStore.watch(StoreName.USER, {
        userBlacklist: onUserBlacklistUpdated
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CUSTOM, {
        currentContactInfo: onCurrentContactInfoUpdated
      });
      TUIStore.unwatch(StoreName.USER, {
        userBlacklist: onUserBlacklistUpdated
      });
    });
    var resetContactInfoUIData = () => {
      contactInfoData.value = {};
      contactInfoBasicList.value = [];
      contactInfoMoreList.value = [];
      contactInfoButtonList.value = [];
    };
    var resetContactSearchingUIData = () => {
      TUIStore.update(StoreName.CUSTOM, 'currentContactInfo', {});
      TUIStore.update(StoreName.CUSTOM, 'currentContactSearchingStatus', false);
      (TUIGlobal === null || TUIGlobal === void 0 ? void 0 : TUIGlobal.closeSearching) && (TUIGlobal === null || TUIGlobal === void 0 ? void 0 : TUIGlobal.closeSearching());
    };
    var onContactInfoEmitSubmit = item => {
      item.editSubmitHandler && item.editSubmitHandler({
        item,
        contactInfoData: contactInfoData.value,
        isBothFriend: isBothFriend.value,
        isInBlackList: isInBlackList.value
      });
    };
    var onContactInfoButtonClicked = item => {
      item.onClick && item.onClick({
        contactInfoData: contactInfoData.value,
        contactInfoMoreList: contactInfoMoreList.value
      });
      if (item.key === 'enterGroupConversation' || item.key === 'enterC2CConversation') {
        emits('switchConversation', contactInfoData.value);
        resetContactSearchingUIData();
      }
    };
    var generateMoreInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        if (!isApplication.value) {
          var _contactInfoData$valu4, _TUIChatEngine$TYPES;
          if (!isGroup.value && !isBothFriend.value && !isInBlackList.value || isGroup.value && !isGroupMember.value && ((_contactInfoData$valu4 = contactInfoData.value) === null || _contactInfoData$valu4 === void 0 ? void 0 : _contactInfoData$valu4.type) !== (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES === void 0 ? void 0 : _TUIChatEngine$TYPES.GRP_AVCHATROOM)) {
            contactMoreInfoConfig.setWords.data = '';
            contactInfoMoreList.value.push(contactMoreInfoConfig.setWords);
          }
          if (!isGroup.value && !isInBlackList.value) {
            var _contactInfoData$valu5;
            contactMoreInfoConfig.setRemark.data = ((_contactInfoData$valu5 = contactInfoData.value) === null || _contactInfoData$valu5 === void 0 ? void 0 : _contactInfoData$valu5.remark) || '';
            contactMoreInfoConfig.setRemark.editing = false;
            contactInfoMoreList.value.push(contactMoreInfoConfig.setRemark);
          }
          if (!isGroup.value && (isBothFriend.value || isInBlackList.value)) {
            contactMoreInfoConfig.blackList.data = isInBlackList.value || false;
            contactInfoMoreList.value.push(contactMoreInfoConfig.blackList);
          }
        } else {
          var _contactInfoData$valu6;
          contactMoreInfoConfig.displayWords.data = ((_contactInfoData$valu6 = contactInfoData.value) === null || _contactInfoData$valu6 === void 0 ? void 0 : _contactInfoData$valu6.wording) || '';
          contactInfoMoreList.value.push(contactMoreInfoConfig.displayWords);
        }
      });
      return function generateMoreInfo() {
        return _ref2.apply(this, arguments);
      };
    }();
    var generateButton = () => {
      var _contactInfoButtonLis3, _contactInfoButtonLis4;
      if (isInBlackList.value) {
        return;
      }
      if (isApplication.value) {
        var _contactInfoData$valu7, _TUIChatEngine$TYPES2;
        if (((_contactInfoData$valu7 = contactInfoData.value) === null || _contactInfoData$valu7 === void 0 ? void 0 : _contactInfoData$valu7.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES2 = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES2 === void 0 ? void 0 : _TUIChatEngine$TYPES2.SNS_APPLICATION_SENT_TO_ME)) {
          var _contactInfoButtonLis, _contactInfoButtonLis2;
          contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis = contactInfoButtonList.value) === null || _contactInfoButtonLis === void 0 || _contactInfoButtonLis.push(contactButtonConfig.refuseFriendApplication);
          contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis2 = contactInfoButtonList.value) === null || _contactInfoButtonLis2 === void 0 || _contactInfoButtonLis2.push(contactButtonConfig.acceptFriendApplication);
        }
      } else {
        if (isGroup.value && isGroupMember.value) {
          var _contactInfoData$valu8, _contactInfoButtonLis5;
          switch ((_contactInfoData$valu8 = contactInfoData.value) === null || _contactInfoData$valu8 === void 0 || (_contactInfoData$valu8 = _contactInfoData$valu8.selfInfo) === null || _contactInfoData$valu8 === void 0 ? void 0 : _contactInfoData$valu8.role) {
            case 'Owner':
              contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis3 = contactInfoButtonList.value) === null || _contactInfoButtonLis3 === void 0 || _contactInfoButtonLis3.push(contactButtonConfig.dismissGroup);
              break;
            default:
              contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis4 = contactInfoButtonList.value) === null || _contactInfoButtonLis4 === void 0 || _contactInfoButtonLis4.push(contactButtonConfig.quitGroup);
              break;
          }
          contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis5 = contactInfoButtonList.value) === null || _contactInfoButtonLis5 === void 0 || _contactInfoButtonLis5.push(contactButtonConfig.enterGroupConversation);
        } else if (!isGroup.value && isBothFriend.value) {
          var _contactInfoButtonLis6, _contactInfoButtonLis7;
          contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis6 = contactInfoButtonList.value) === null || _contactInfoButtonLis6 === void 0 || _contactInfoButtonLis6.push(contactButtonConfig.deleteFriend);
          contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis7 = contactInfoButtonList.value) === null || _contactInfoButtonLis7 === void 0 || _contactInfoButtonLis7.push(contactButtonConfig.enterC2CConversation);
        } else {
          if (isGroup.value) {
            var _contactInfoButtonLis8, _contactInfoData$valu9, _TUIChatEngine$TYPES3;
            contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis8 = contactInfoButtonList.value) === null || _contactInfoButtonLis8 === void 0 || _contactInfoButtonLis8.push(((_contactInfoData$valu9 = contactInfoData.value) === null || _contactInfoData$valu9 === void 0 ? void 0 : _contactInfoData$valu9.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES3 = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES3 === void 0 ? void 0 : _TUIChatEngine$TYPES3.GRP_AVCHATROOM) ? contactButtonConfig.joinAVChatGroup : contactButtonConfig.joinGroup);
          } else {
            var _contactInfoButtonLis9;
            contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis9 = contactInfoButtonList.value) === null || _contactInfoButtonLis9 === void 0 || _contactInfoButtonLis9.push(contactButtonConfig.addFriend);
          }
        }
      }
    };
    function onUserBlacklistUpdated(userBlacklist) {
      blackList.value = userBlacklist;
    }
    function onCurrentContactInfoUpdated(_x) {
      return _onCurrentContactInfoUpdated.apply(this, arguments);
    }
    function _onCurrentContactInfoUpdated() {
      _onCurrentContactInfoUpdated = _asyncToGenerator(function* (contactInfo) {
        var _Object$keys;
        if (contactInfoData.value && contactInfo && JSON.stringify(contactInfoData.value) === JSON.stringify(contactInfo)) {
          return;
        }
        resetContactInfoUIData();
        // deep clone
        contactInfoData.value = deepCopy(contactInfo) || {};
        if (!contactInfoData.value || ((_Object$keys = Object.keys(contactInfoData.value)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0) {
          return;
        }
        contactInfoBasicList.value = generateContactInfoBasic(contactInfoData.value);
        isBothFriend.value = yield isFriend(contactInfoData.value);
        generateMoreInfo();
        generateButton();
        if (contactInfo.infoKeyList) {
          contactInfoMoreList.value = contactInfo.infoKeyList.map(key => {
            return contactMoreInfoConfig[key];
          });
        }
        if (contactInfo.btnKeyList) {
          contactInfoButtonList.value = contactInfo.btnKeyList.map(key => {
            return contactButtonConfig[key];
          });
        }
      });
      return _onCurrentContactInfoUpdated.apply(this, arguments);
    }
    return (_ctx, _cache) => {
      var _component_el_popconfirm = _resolveComponent("el-popconfirm");
      return typeof _unref(contactInfoData) === 'object' && Object.keys(_unref(contactInfoData)).length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['tui-contact-info', !_unref(isPC) && 'tui-contact-info-h5'])
      }, [!_unref(isPC) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['tui-contact-info-header', !_unref(isPC) && 'tui-contact-info-h5-header'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['tui-contact-info-header-icon', !_unref(isPC) && 'tui-contact-info-h5-header-icon']),
        onClick: resetContactSearchingUIData
      }, [_createVNode(Icon, {
        file: _unref(backSVG)
      }, null, 8, ["file"])], 2), _createElementVNode("div", {
        class: _normalizeClass(['tui-contact-info-header-title', !_unref(isPC) && 'tui-contact-info-h5-header-title'])
      }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.添加好友/群聊")), 3)], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(['tui-contact-info-basic', !_unref(isPC) && 'tui-contact-info-h5-basic'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['tui-contact-info-basic-text', !_unref(isPC) && 'tui-contact-info-h5-basic-text'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['tui-contact-info-basic-text-name', !_unref(isPC) && 'tui-contact-info-h5-basic-text-name'])
      }, _toDisplayString(_unref(generateContactInfoName)(_unref(contactInfoData))), 3)], 2), _createElementVNode("img", {
        class: _normalizeClass(['tui-contact-info-basic-avatar', !_unref(isPC) && 'tui-contact-info-h5-basic-avatar']),
        src: _unref(generateAvatar)(_unref(contactInfoData))
      }, null, 10, _hoisted_1)], 2), _unref(contactInfoMoreList)[0] ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['tui-contact-info-more', !_unref(isPC) && 'tui-contact-info-h5-more'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactInfoMoreList), item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.key,
          class: _normalizeClass(['tui-contact-info-more-item', !_unref(isPC) && 'tui-contact-info-h5-more-item', item.labelPosition === _unref(CONTACT_INFO_LABEL_POSITION).TOP ? 'tui-contact-info-more-item-top' : 'tui-contact-info-more-item-left'])
        }, [_createElementVNode("div", {
          class: _normalizeClass(['tui-contact-info-more-item-label', !_unref(isPC) && 'tui-contact-info-h5-more-item-label'])
        }, _toDisplayString("".concat(_unref(TUITranslateService).t("TUIContact.".concat(item.label)))), 3), _createElementVNode("div", {
          class: _normalizeClass(['tui-contact-info-more-item-content', !_unref(isPC) && 'tui-contact-info-h5-more-item-content'])
        }, [!item.editing ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['tui-contact-info-more-item-content-text', !_unref(isPC) && 'tui-contact-info-h5-more-item-content-text'])
        }, [_createElementVNode("div", {
          class: _normalizeClass(['tui-contact-info-more-item-content-text-data', !_unref(isPC) && 'tui-contact-info-h5-more-item-content-text-data'])
        }, _toDisplayString(item.data), 3), item.editable ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['tui-contact-info-more-item-content-text-icon', !_unref(isPC) && 'tui-contact-info-h5-more-item-content-text-icon']),
          onClick: $event => setEditing(item)
        }, [_createVNode(Icon, {
          file: _unref(editSVG),
          width: "14px",
          height: "14px"
        }, null, 8, ["file"])], 10, _hoisted_2)) : _createCommentVNode("", true)], 2)) : item.editType === _unref(CONTACT_INFO_MORE_EDIT_TYPE).INPUT ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          "onUpdate:modelValue": $event => item.data = $event,
          class: _normalizeClass(['tui-contact-info-more-item-content-input', !_unref(isPC) && 'tui-contact-info-h5-more-item-content-input']),
          type: "text",
          onConfirm: $event => onContactInfoEmitSubmit(item),
          onKeyup: _withKeys($event => onContactInfoEmitSubmit(item), ["enter"])
        }, null, 42, _hoisted_3)), [[_vModelText, item.data]]) : item.editType === _unref(CONTACT_INFO_MORE_EDIT_TYPE).TEXTAREA ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 2,
          "onUpdate:modelValue": $event => item.data = $event,
          class: _normalizeClass(['tui-contact-info-more-item-content-textarea', !_unref(isPC) && 'tui-contact-info-h5-more-item-content-textarea']),
          "confirm-type": "done"
        }, null, 10, _hoisted_4)), [[_vModelText, item.data]]) : item.editType === _unref(CONTACT_INFO_MORE_EDIT_TYPE).SWITCH ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          onClick: $event => onContactInfoEmitSubmit(item)
        }, [_createVNode(SwitchBar, {
          value: item.data
        }, null, 8, ["value"])], 8, _hoisted_5)) : _createCommentVNode("", true)], 2)], 2);
      }), 128))], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(['tui-contact-info-button', !_unref(isPC) && 'tui-contact-info-h5-button'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactInfoButtonList), item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.key
        }, [item.key == 'dismissGroup' || item.key == 'quitGroup' ? (_openBlock(), _createBlock(_component_el_popconfirm, {
          key: 0,
          title: item.label + '?',
          onConfirm: $event => onContactInfoButtonClicked(item)
        }, {
          reference: _withCtx(() => [_createElementVNode("button", {
            class: _normalizeClass(['tui-contact-info-button-item', !_unref(isPC) && 'tui-contact-info-h5-button-item', item.type === _unref(CONTACT_INFO_BUTTON_TYPE).CANCEL ? "tui-contact-info-button-item-cancel" : "tui-contact-info-button-item-submit"])
          }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(item.label))), 3)]),
          _: 2
        }, 1032, ["title", "onConfirm"])) : (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: $event => onContactInfoButtonClicked(item),
          class: _normalizeClass(['tui-contact-info-button-item', !_unref(isPC) && 'tui-contact-info-h5-button-item', item.type === _unref(CONTACT_INFO_BUTTON_TYPE).CANCEL ? "tui-contact-info-button-item-cancel" : "tui-contact-info-button-item-submit"])
        }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(item.label))), 11, _hoisted_6))]);
      }), 128))], 2)], 2)) : _createCommentVNode("", true);
    };
  }
});